import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getConfirmAnalyses,
  getConfirmAnalysis,
  clearLocalConfirmAnalyses,
  clearLocalActiveConfirmAnalysis
} from './actions';

const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 }},
  confirmAnalysis: { id: '', status: '', updated_at: '' },
  loading: { all: false, confirmAnalysis: false }
};

const slice = createSlice({
  name: 'confirmAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getConfirmAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getConfirmAnalyses.fulfilled, (state, action) => {
        const { confirm_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...confirm_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getConfirmAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getConfirmAnalysis.pending, (state) => {
        state.loading.confirmAnalysis = true;
      })
      .addCase(getConfirmAnalysis.fulfilled, (state, action) => {
        const { data: { confirm_analysis }, cable } = action.payload;
        const foundedConfirmAnalysis = !!_find(state.all.data, (s) => s.id === confirm_analysis.id);
        const updatedConfirmAnalysis = { ...state.confirmAnalysis, ...confirm_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedConfirmAnalysis ? _map(state.all.data, (e) => e.id === confirm_analysis.id ? { ...e, ...confirm_analysis } : e) : [...[confirm_analysis], ...oldAllData]; 
        const pagination = foundedConfirmAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.confirmAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedConfirmAnalysis && !cable) state.confirmAnalysis = updatedConfirmAnalysis;       
      })
      .addCase(getConfirmAnalysis.rejected, (state) => {
        state.loading.confirmAnalysis = false;
      })
      .addCase(clearLocalConfirmAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveConfirmAnalysis, state => {
        state.confirmAnalysis = initialState.confirmAnalysis;
      })
  }
})

export default slice.reducer;